import React from 'react';
import { FormControl, TextField, Box } from '@mui/material';
import RegularButton from 'components/CustomButtons/Button';
import { useForm } from 'hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { unassignIotDevice } from 'redux/actions/iotDevices/iotDevicesActions';

const INITIAL = { changeReason: '' };
const RULES = { changeReason: { required: true } };

export const IotDeviceUnassignForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { iotDeviceSelected } = useSelector(({ iotDevices }) => iotDevices);
  const { isLoadingComp } = useSelector(({ search }) => search);

  const { values, onChange, validate, errors } = useForm(INITIAL, RULES);

  const handleSubmit = () => {
    validate([], () => {
      dispatch(unassignIotDevice(
        iotDeviceSelected.id,
        { changeReason: values.changeReason },
        onClose,
      ));
    });
  };

  return (
    <FormControl fullWidth style={{ display: 'flex', gap: 12, marginTop: 16 }}>
      <TextField
        label="Razón de desvinculación *"
        name="changeReason"
        value={values.changeReason}
        onChange={onChange}
        variant="outlined"
        multiline
        rows={3}
        error={!!errors.changeReason}
        helperText={errors.changeReason}
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <RegularButton color="danger" onClick={onClose}>Cancelar</RegularButton>
        <RegularButton
          color="warning"
          onClick={handleSubmit}
          disabled={isLoadingComp?.loadingIotDevices}
        >
          Desvincular
        </RegularButton>
      </Box>
    </FormControl>
  );
};
